import React from 'react';

// Components
import SheetContainer, { Content, Overlay, Sheet } from '../structural/sheet';
import MobileGestureShakeContextMenuContent from './MobileGestureShakeContextMenuContent';

// Utils
import useSheet from '../structural/sheet/hooks/useSheet';

import useAttachGestureShake from '../../capacitor/hooks/useAttachGestureShake';

// Constants
import { SheetId } from '../structural/sheet/sheetTypes';

const MobileGestureShakeContextMenu = () => {
    const sheetProps = useSheet(SheetId.GestureShakeMenu);
    const { dispatchCloseSheet } = sheetProps;

    useAttachGestureShake();

    return (
        <SheetContainer className="MobileGestureShakeSheet" defaultSnapPoint={'0.5max'} {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <MobileGestureShakeContextMenuContent dispatchCloseSheet={dispatchCloseSheet} />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileGestureShakeContextMenu;
